import Datatable from "../../bootstrap-table/LegacyMuiDatatable";

export default Datatable;
